import React from 'react';

// DesignerRail — the tool-category column. Visually a vertical rail on
// desktop and a horizontal bottom bar on mobile (same DOM, layout
// swapped via CSS media query). Each icon is a tool category — clicking
// toggles the corresponding side panel open or closed.

// Inline SVGs kept simple and consistent (1.6 stroke, no fill, rounded
// joins) so they read at 22 px in the rail and 20 px on mobile.
const IconText = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 6h14" /><path d="M12 6v13" /><path d="M9 19h6" />
  </svg>
);
const IconShapes = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3.5" y="3.5" width="9" height="9" rx="1.5" />
    <circle cx="16.5" cy="16" r="4.5" />
  </svg>
);
const IconAmount = ({ currency }) => (
  <span className="v2-cd-rail-glyph" aria-hidden>{currency}</span>
);
const IconImage = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3.5" y="4.5" width="17" height="14" rx="2" />
    <circle cx="8.5" cy="10" r="1.3" fill="currentColor" stroke="none" />
    <path d="M3.5 16l5-5 4 4 3.5-3.5 4.5 4" />
  </svg>
);
const IconBackground = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
    {/* Hatched diagonals — reads as "background fill / pattern" and
        is clearly distinct from the photo icon's mountain shape. */}
    <path d="M10 3.5L3.5 10M20.5 12L12 20.5" />
  </svg>
);

const ITEMS = [
  { id: 'text',       label: 'Text',       Icon: IconText },
  { id: 'shapes',     label: 'Shapes',     Icon: IconShapes },
  { id: 'amount',     label: 'Amount',     Icon: IconAmount },
  { id: 'image',      label: 'Image',      Icon: IconImage },
  { id: 'background', label: 'Background', Icon: IconBackground },
];

const DesignerRail = ({ active, onSelect, currency = '£' }) => (
  <nav className="v2-cd-rail" aria-label="Tools">
    {ITEMS.map((item) => {
      const isActive = active === item.id;
      const Icon = item.Icon;
      return (
        <button
          key={item.id}
          type="button"
          className={`v2-cd-rail-btn ${isActive ? 'is-active' : ''}`}
          onClick={() => onSelect(isActive ? null : item.id)}
          aria-pressed={isActive}
          aria-label={item.label}
        >
          <span className="v2-cd-rail-icon">
            {item.id === 'amount' ? <Icon currency={currency} /> : <Icon />}
          </span>
          <span className="v2-cd-rail-label">{item.label}</span>
        </button>
      );
    })}
  </nav>
);

export default DesignerRail;
